import API from './index';

const api = {
    getBackendVersion() {
        return API.basicAPI({
            url: `/version`,
            method: 'GET',
        });
    },
};

export default api;
